import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 用户分页
    GetUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/User/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存用户
    SaveUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/User/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除用户
    DeleteUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/User/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取公司列表数据
    // getcompanylist({ commit }, params) {
    //   return new Promise((resolve, reject) => {
    //     request.get('SystemManage/Organize/GetGridJson', params).then(response => {
    //       resolve(response)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 获取角色列表数据
    getrolelist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Role/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取部门列表数据(跟公司列表是联动关系)
    getdepartment({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Organize/GetDepartListByOrganizeID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取岗位列表数据
    getpostlist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Duty/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
